export type SonioxEndpointValue = number | string | null | undefined;

export const normalizeSonioxEndpointNumber = (value: SonioxEndpointValue): number | null =>
    value === null || value === undefined || String(value).trim() === '' ? null : Number(value);

export const getSonioxEndpointSensitivityError = (value: SonioxEndpointValue, model?: string): string => {
    const sensitivity = normalizeSonioxEndpointNumber(value);
    if (sensitivity === null) return '';
    if (!Number.isFinite(sensitivity) || sensitivity < -1 || sensitivity > 1)
        return 'Soniox endpoint sensitivity must be between -1 and 1';
    const version = /^stt-rt-v(\d+)(?:-|$)/i.exec(model ?? '');
    if (version && Number(version[1]) < 5)
        return 'Soniox endpoint sensitivity requires a v5 or newer model';
    return '';
};

export const getSonioxMaxEndpointDelayError = (value: SonioxEndpointValue): string => {
    const delay = normalizeSonioxEndpointNumber(value);
    if (delay === null) return '';
    return Number.isInteger(delay) && delay >= 500 && delay <= 3000
        ? '' : 'Soniox maximum endpoint delay must be a whole number between 500 and 3000 milliseconds';
};

interface SonioxEndpointConfiguration {
    asrProvider?: string;
    asrTier?: string;
    asrModel?: string;
    sonioxEndpointSensitivity?: SonioxEndpointValue;
    sonioxMaxEndpointDelayMS?: SonioxEndpointValue;
}

export const isSonioxEndpointProvider = (provider?: string, tier?: string): boolean =>
    provider?.toLowerCase() === 'soniox' || tier?.toLowerCase() === 'soniox';

export const getSonioxEndpointErrors = (config: SonioxEndpointConfiguration) => {
    const usesSoniox = isSonioxEndpointProvider(config.asrProvider, config.asrTier);
    return {
        sonioxEndpointSensitivity: usesSoniox
            ? getSonioxEndpointSensitivityError(config.sonioxEndpointSensitivity, config.asrModel) : '',
        sonioxMaxEndpointDelayMS: usesSoniox
            ? getSonioxMaxEndpointDelayError(config.sonioxMaxEndpointDelayMS) : '',
    };
};
